import * as React from 'react'
import { alpha, styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import useColor from '../hooks/useColor'
interface ColorSwitchProps extends Omit<SwitchProps, 'color'> {
  color?: string
}

const ColorSwitch: React.FC<ColorSwitchProps> = ({ color, ...props }) => {
  const getColor = useColor()
  if (color) color = getColor(color)

  const StyledSwitch = styled(Switch)(({ theme }) =>
    color
      ? {
          '& .MuiSwitch-switchBase.Mui-checked': {
            color,
            '&:hover': {
              backgroundColor: alpha(color, theme.palette.action.hoverOpacity),
            },
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: color,
          },
        }
      : {}
  )

  return <StyledSwitch {...props} />
}

export default ColorSwitch
